import { plinkoBasis } from '../plinkoCore/constants/plinkoConfigs';

export const getGameCanvas = () => document.getElementById('canvas-game');

export const getGameCanvasContext = () => {
  return getGameCanvas().getContext('2d');
};

export const resizeGameCanvas = (width, height) => {
  const canvas = getGameCanvas();
  canvas.width = width;
  canvas.height = height;
};

export const getGameCanvasStandards = () => ({
  canvas: getGameCanvas(),
  ctx: getGameCanvasContext(),
});

export function getBallsConfigs(line) {
  const ac = plinkoBasis.c.x - plinkoBasis.a.x;
  const bd = plinkoBasis.d.y - plinkoBasis.b.y;
  const heightBetweenLines = bd / (line + 1);
  const distanceFromTop = plinkoBasis.b.y + heightBetweenLines;
  const firstLineLength = ((2 * heightBetweenLines) / bd) * ac;

  return {
    fixedBallRadius: firstLineLength / 14,
    heightBetweenLines,
    widthBetweenLines: firstLineLength / 2,
    distanceFromTop,
    mainBallRadius: (firstLineLength / 14) * 2.125,
  };
}

export const getFixedBallsCoordinates = (lines, configs) => {
  const coordinatesArray = [];
  const currentLineConfigs = getBallsConfigs(lines);
  const startCirclesCount = 3;
  const endCirclesCount = lines + 2;
  const widthBetweenCircles = currentLineConfigs.widthBetweenLines;
  const middleOfWidth = configs.width / 2;
  let yLineCoordinate = 0;
  // eslint-disable-next-line
  for (let i = startCirclesCount; i <= endCirclesCount; i += 1) {
    yLineCoordinate += currentLineConfigs.heightBetweenLines;

    if (i % 2 === 0) {
      let k = 0;
      for (let j = i / 2 + 1; j <= i; j += 1) {
        let x;

        x = middleOfWidth + widthBetweenCircles / 2 + widthBetweenCircles * k;

        coordinatesArray.push({
          x: x,
          y: yLineCoordinate + currentLineConfigs.distanceFromTop,
        });

        x = middleOfWidth - widthBetweenCircles / 2 - widthBetweenCircles * k;

        coordinatesArray.push({
          x: x,
          y: yLineCoordinate + currentLineConfigs.distanceFromTop,
        });

        k += 1;
      }
    } else {
      let k = 0;
      for (let j = Math.ceil(i / 2); j <= i; j += 1) {
        let x;
        if (j === Math.ceil(i / 2)) {
          x = middleOfWidth;

          coordinatesArray.push({
            x: x,
            y: yLineCoordinate + currentLineConfigs.distanceFromTop,
          });
        } else {
          x = middleOfWidth + widthBetweenCircles * k;

          coordinatesArray.push({
            x: x,
            y: yLineCoordinate + currentLineConfigs.distanceFromTop,
          });

          x = middleOfWidth - widthBetweenCircles * k;

          coordinatesArray.push({
            x: x,
            y: yLineCoordinate + currentLineConfigs.distanceFromTop,
          });
        }
        k += 1;
      }
    }
  }

  return coordinatesArray;
};
